import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation, RelatedBlock } from '@wix/da-papi-types';
import DeviationDuperbrowseContext from '../../../../Duperbrowse/DeviationDuperbrowseContext';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import DeviationDumbViewWithIcon from '../../../../DeviationViews/DumboWithIcon';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import {
  getDeviationResourceType,
  getTranslatedDeviationTitle,
} from '../../../../DeviationViews/_helpers';
import ContainerSize from '../../../../ContainerSize';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import s from './SingleColumnTextual.scss';

const thumbHeight = parseInt(s['sidebar-thumb-height'], 10);
const thumbWidth = parseInt(s['sidebar-thumb-width'], 10);

interface Props {
  block: RelatedBlock;
  deviation: PapiDeviation;
}

/** Sidebar block layout id 2 */
const SingleColumnTextual: React.FC<React.PropsWithChildren<Props>> = ({
  block,
  deviation: parentDeviation,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  return (
    <SidebarBlockWrapper deviation={parentDeviation} block={block}>
      <ContainerSize>
        {({ containerWidth }) => (
          <DeviationDuperbrowseContext
            streamId={`sidebar-textual-${block.contentType}`}
            deviations={block.deviations ?? []}
            parent={{
              typeId: getDeviationResourceType(parentDeviation),
              itemId: parentDeviation.deviationId,
            }}
          >
            {block.deviations?.map((deviation, index) => (
              <BiLoggerContextProvider key={index} value={{ _rankIndex: index }}>
                <DeviationLink
                  deviation={deviation}
                  key={deviation.deviationId}
                  className={s['thumb']}
                  title={getTranslatedDeviationTitle(deviation, t)}
                >
                  <DeviationDumbViewWithIcon
                    deviation={deviation}
                    width={isMobile ? containerWidth : thumbWidth}
                    height={thumbHeight}
                    greenLikeCrop
                  />
                </DeviationLink>
              </BiLoggerContextProvider>
            ))}
          </DeviationDuperbrowseContext>
        )}
      </ContainerSize>
    </SidebarBlockWrapper>
  );
};
SingleColumnTextual.displayName = 'SingleColumnTextual';

export default SingleColumnTextual;
